export enum TraderRatesBulkTarget {
    TRADER_FEE = 'TRADER_FEE',
    TEAM_LEAD_CUT = 'TEAM_LEAD_CUT',
}
